export default __webpack_public_path__ + "static/media/profile.8bcaf8fb.png";